const IMAGE_HOST = 'https://frankiecao1.github.io';

// Maps menu categories to their image directory on the image host.
const CATEGORY_DIRS: { [category: string]: string } = {
  'Soup': 'soups',
  'Appetizers': 'appetizers',
  'Curry': 'curry',
  'Egg Foo Young': 'egg-foo-young',
  'Rice': 'rice',
  'Sweet & Sour': 'sweet-sour',
  'Chop Suey': 'chop-suey',
  'Beef': 'beef',
  'Chicken': 'chicken',
  'Seafood': 'seafood',
  'Pork': 'pork',
  'Vegetarian': 'vegetarian',
  'Salads': 'salads',
  'Canadian Dishes': 'canadian',
  'Noodle': 'noodles',
  'Special Combination Plate': 'combos',
  'Family Dinners': 'family',
  'Canadian Combo': 'canadian-combos'
};

const slugify = (name: string): string =>
  name.toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-');

export const getFoodImageUrl = (itemName: string, category: string): string => {
  const categoryDir = CATEGORY_DIRS[category] || 'other';
  return `${IMAGE_HOST}/${categoryDir}/${slugify(itemName)}.webp`;
};
